/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAbsoluteDatalayerBegincheckoutData } from './absolute-datalayer-begincheckout.data';
import { IAbsoluteDatalayerBegincheckoutProps } from './absolute-datalayer-begincheckout.props.autogenerated';

export interface IAbsoluteDatalayerBegincheckoutViewProps extends IAbsoluteDatalayerBegincheckoutProps<IAbsoluteDatalayerBegincheckoutData> {

    productName: string;

}

/**
 *
 * AbsoluteDatalayerBegincheckout component
 * @extends {React.PureComponent<IAbsoluteDatalayerBegincheckoutProps<IAbsoluteDatalayerBegincheckoutData>>}
 */
class AbsoluteDatalayerBegincheckout extends React.PureComponent<IAbsoluteDatalayerBegincheckoutProps<IAbsoluteDatalayerBegincheckoutData>> {
    public render(): JSX.Element | null {

        //const { config } = this.props;
        
        
        const ProductName = ''

        const DataLayerViewProps = {
            ...this.props,
            ProductName: ProductName
        }
        


        return this.props.renderView(DataLayerViewProps);
    }
}

export default AbsoluteDatalayerBegincheckout;
